export function getUniqueKey(name, obj) {
    var unique = name;
    var no = 1;
    while (unique in obj) {
        unique = name + "_" + no;
        no++;
    }
    return unique;
}
export default getUniqueKey;

//# sourceMappingURL=getUniqueKey.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/utils/getUniqueKey.js
// module id = 65
// module chunks = 0